import {
  Form,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Input,
  Space,
  notification,
  Select,
  Button,
} from "antd";
import { useState, useRef, useEffect } from "react";

const NotInGroup = ({ handleLogout }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
        flexDirection: "column",
      }}
    >
      <h1>You are currently not associated to the proper Group</h1>
      <Button
        onClick={() => handleLogout()}
        style={{ height: "12%", width: "7%" }}
        type="primary"
        danger
        size={"large"}
      >
        Logout
      </Button>
    </div>
  );
};

export default NotInGroup;
